export var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "PENDING";
    UserStatus["ENABLED"] = "ENABLED";
    UserStatus["DISABLED"] = "DISABLED";
})(UserStatus || (UserStatus = {}));
export var RoleName;
(function (RoleName) {
    RoleName["ADMIN"] = "admin";
    RoleName["CARE"] = "care";
    RoleName["AGENT"] = "agent";
    RoleName["AGENT_ADMIN"] = "agent_admin";
    RoleName["AGENT_SUPPORT"] = "agent_support";
    RoleName["PARTNERSHIPS"] = "partnerships";
    RoleName["MARKETING"] = "marketing";
    RoleName["PHOTO"] = "photo";
})(RoleName || (RoleName = {}));
